import BaseNumberVTextField from './BaseNumberVTextField'
import { format24As12 } from '~/cynqueModules/utils/format24As12'

// Vuetify 3 migration: inherits the <v-text-field> wrapper machinery from
// BaseNumberVTextField. parseNumeric:false — the time string is formatted as-is.
// blurredFormat now uses the pure format24As12 (was window.$nuxt.$format24As12, gone
// in Nuxt 4).
export default {
  extends: BaseNumberVTextField,
  props: {
    parseNumeric: {
      type: Boolean,
      default: false,
    },
    blurredFormat: {
      type: Function,
      default: (v) => {
        if (v) return format24As12(v)
      },
    },
  },
}
